/* tslint:disable */
/* eslint-disable */
/**
 * Inhouse API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentMethodOverridableConfiguration } from './PaymentMethodOverridableConfiguration';
import {
    PaymentMethodOverridableConfigurationFromJSON,
    PaymentMethodOverridableConfigurationFromJSONTyped,
    PaymentMethodOverridableConfigurationToJSON,
    PaymentMethodOverridableConfigurationToJSONTyped,
} from './PaymentMethodOverridableConfiguration';

/**
 * 
 * @export
 * @interface PaymentMethodConfiguration
 */
export interface PaymentMethodConfiguration {
    /**
     * 
     * @type {PaymentMethodOverridableConfiguration}
     * @memberof PaymentMethodConfiguration
     */
    overridableConfiguration: PaymentMethodOverridableConfiguration;
    /**
     * 
     * @type {boolean}
     * @memberof PaymentMethodConfiguration
     */
    visibleInApps: boolean;
}

/**
 * Check if a given object implements the PaymentMethodConfiguration interface.
 */
export function instanceOfPaymentMethodConfiguration(value: object): value is PaymentMethodConfiguration {
    if (!('overridableConfiguration' in value) || value['overridableConfiguration'] === undefined) return false;
    if (!('visibleInApps' in value) || value['visibleInApps'] === undefined) return false;
    return true;
}

export function PaymentMethodConfigurationFromJSON(json: any): PaymentMethodConfiguration {
    return PaymentMethodConfigurationFromJSONTyped(json, false);
}

export function PaymentMethodConfigurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaymentMethodConfiguration {
    if (json == null) {
        return json;
    }
    return {
        
        'overridableConfiguration': PaymentMethodOverridableConfigurationFromJSON(json['overridableConfiguration']),
        'visibleInApps': json['visibleInApps'],
    };
}

export function PaymentMethodConfigurationToJSON(json: any): PaymentMethodConfiguration {
    return PaymentMethodConfigurationToJSONTyped(json, false);
}

export function PaymentMethodConfigurationToJSONTyped(value?: PaymentMethodConfiguration | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'overridableConfiguration': PaymentMethodOverridableConfigurationToJSON(value['overridableConfiguration']),
        'visibleInApps': value['visibleInApps'],
    };
}

